import base from 'components/base'
import componentInit from 'components/componentInit'
import mainMenu from 'components/mainMenu'
import $ from 'jquery'
import 'jquery.easing'
import 'jquery.scrollto'

class anchorLink extends base
{
  element = null

  constructor(element)
  {
    super()

    this.element = $(element).get(0)
    this.bindEvents()
  }

  bindEvents()
  {
    $(this.element).on('click.'+ module.id, (event) =>
    {
      event.preventDefault()
      this.scrollToAnchor($(this.element).attr('href'))
    })
  }

  scrollToAnchor(anchorName)
  {
    anchorName = anchorName.replace(/^#+/, '')
    let anchor = $('a[name="'+ anchorName +'"]').get(0)
    if(anchor)
      this.scrollToElement(anchor)
  }

  scrollToElement(element)
  {
    let mainMenuElement = $('#main-menu').get(0)
    if(mainMenuElement)
      mainMenu.close()

    let params = {
      axis: 'y',
      duration: 1000,
      easing: 'easeOutExpo',
      offset: $('#site-header').outerHeight() * -1
    }

    let alphabetNavigation = $('.alphabet-navigation').get(0)
    if(alphabetNavigation)
      params.offset += $(alphabetNavigation).outerHeight() * -1

    // Leave a bit of space between header and the element.
    params.offset -= 15

    $.scrollTo(element, params)
  }
}

componentInit.prototype.callbacks[module.id] = function(parentElement)
{
  let elements = $(parentElement).find('a[href^="#"]').get()
  for(let element of elements)
    new anchorLink(element)
}

export default anchorLink



// WEBPACK FOOTER //
// ./vendor/response200/kustantajat/applications/publicFrontend/scripts/components/anchorLink.js